var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartial11Px = function SvgPartial11Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none",
    viewBox: "0 0 11 11"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#partial-11px_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8a6a00",
    d: "M9.625 5.5A4.126 4.126 0 0 0 5.5 1.375v8.25A4.126 4.126 0 0 0 9.625 5.5M0 5.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "partial-11px_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h11v11H0z"
  })))));
};
export default SvgPartial11Px;